function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#E84E30"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.59625,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.02131,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.3931,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.8182,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.76609 12.96C6.10552 12.2996 6.60303 11.6996 7.2302 11.1942C7.85738 10.6887 8.60195 10.2878 9.4214 10.0143C10.2408 9.74075 11.1191 9.59996 12.0061 9.59996C12.8931 9.59996 13.7713 9.74075 14.5908 10.0143C15.4102 10.2878 16.1548 10.6887 16.782 11.1942C17.4092 11.6996 17.9067 12.2996 18.2461 12.96",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3087 5.6584C16.3087 5.6584 17.656 6.26924 18.0668 7.2925C18.2456 7.73768 17.9658 8.26884 17.4414 8.47949C16.9164 8.69003 16.3469 8.49986 16.1681 8.05468C15.9692 7.5592 16.3087 5.6584 16.3087 5.6584Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7071 8.05782C18.7071 8.05782 20.0545 8.66866 20.4653 9.69192C20.644 10.1371 20.3642 10.6683 19.8399 10.8789C19.3149 11.0894 18.7453 10.8993 18.5666 10.4541C18.3677 9.95862 18.7071 8.05782 18.7071 8.05782Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4736 2.1751L15.6644 2.74679",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M8.199 2.76166L10.3821 2.16137",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var Svg8Severe = function Svg8Severe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg8Severe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/8_Severe.482ca85f.svg";
export { ForwardRef as ReactComponent };